import { SnackBarService } from '../../../../../services/snackbar.service';
import { MessageService } from './../../../../../services/messages.service';
import { MdDialogRef } from '@angular/material';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApplicationValue } from 'app/services/warmup/application-type.model';
import { ApplicationTypeConstants } from 'app/services/warmup/warmup.service';
import { Observable } from 'rxjs/Observable';
import { WarmUpService } from './../../../../../services/warmup/warmup.service';
import { OnInit, Component, ChangeDetectorRef } from '@angular/core';
import { SanctionMatchRecord } from 'app/entities/monitoring/actual/sanction-matches.model';
import { SanctionEntity } from 'app/entities/monitoring/actual/sanction-matches.model';
import { SanctionService } from 'app/entities/monitoring/actual/sanction/sanction.service';

@Component({
  templateUrl: './resolve-sanction.component.html',
})

/**
 * Dialog component to resolve sanction match.
 *
 * @author mohit.khurana@vernuso.com  (Mohit Khurana)
 */
export class ResolveSanctionMatchComponent implements OnInit {
  resolveForm: FormGroup;
  sanctionMatchRecord: SanctionMatchRecord;
  relationEntityId: number;
  matchResolutions: ApplicationValue[];
  selectedMatchResolution: string;
  falseMatchReasons: ApplicationValue[];
  formErrors = {
    'matchResolution': '',
  };

  validationMessages = {
    'matchResolution': {
      'required': 'Required field value.',
    },
  };

  constructor(private sanctionService: SanctionService,
    private warmUpService: WarmUpService,
    private cdr: ChangeDetectorRef,
    private formBuilder: FormBuilder,
    public dialogRef: MdDialogRef<any>,
    private snackBarService: SnackBarService) { }

  ngOnInit() {
    this.buildForm();
    this.setUpMatchResolutions(
      this.warmUpService.getApplicationValue(ApplicationTypeConstants.SANCTION_MATCH_RESOLUTION));
    this.setUpFalseMatchReasons(
      this.warmUpService.getApplicationValue(ApplicationTypeConstants.FALSE_MATCH_REASONS));
    this.populateForm();
  }

  // @todo This function might get updated once REST is available.
  buildForm() {
    this.resolveForm = this.formBuilder.group({
      matchResolutionControl: ['', Validators.required],
      comments: [''],
      falseMatch: [''],
    });
    this.onValueChanged();
  }

  onValueChanged(data?: any) {
    if (!this.resolveForm) {
      return;
    }
    const form = this.resolveForm;
    for (const field in this.formErrors) {
      // clear previous error message (if any)
      this.formErrors[field] = '';
      const control = form.get(field);
      if (control && control.touched && !control.valid) {
        const messages = this.validationMessages[field];
        for (const key in control.errors) {
          this.formErrors[field] += messages[key] + ' ';
        }
      }
    }
  }

  populateForm() {
    if (this.sanctionMatchRecord) {
      this.resolveForm.patchValue({
        matchResolutionControl: this.sanctionMatchRecord.matchResolution,
        comments: this.sanctionMatchRecord.comments,
        falseMatch: this.sanctionMatchRecord.falseMatchReason
      });
      this.selectedMatchResolution = this.sanctionMatchRecord.matchResolution.toString();
    }
  }

  setUpMatchResolutions(dropDownValues: any) {
    if (dropDownValues instanceof Observable) {
      dropDownValues.subscribe(
        response => {
          this.warmUpService.setApplicationTypeInLS(response);
          this.matchResolutions = response.values;
          this.cdr.detectChanges();
        }
      );
    } else {
      this.matchResolutions = dropDownValues;
    }
  }

  setUpFalseMatchReasons(dropDownValues: any) {
    if (dropDownValues instanceof Observable) {
      dropDownValues.subscribe(
        response => {
          this.warmUpService.setApplicationTypeInLS(response);
          this.falseMatchReasons = response.values;
          this.cdr.detectChanges();
        }
      );
    } else {
      this.falseMatchReasons = dropDownValues;
    }
  }

  selectMatchResolution(event) {
    this.selectedMatchResolution = event.value;
  }

  isSelectedMatchFalse(): boolean {
    if (this.matchResolutions) {
      const falseMatchId = this.matchResolutions.find(matchResolution => matchResolution.name === 'False').id;
      return this.selectedMatchResolution == falseMatchId.toString();
    }
    return false;
  }

  onSubmit({ value, valid }) {
    const sanctionMatchRecord = new SanctionMatchRecord();
    const sanctionEntity = new SanctionEntity();
    sanctionEntity.id = this.sanctionMatchRecord.sanctionEntity.id;
    sanctionMatchRecord.sanctionEntity = sanctionEntity;
    sanctionMatchRecord.relationEntityId = this.relationEntityId;
    sanctionMatchRecord.matchResolution = value.matchResolutionControl;
    sanctionMatchRecord.falseMatchReason = value.falseMatch;
    sanctionMatchRecord.comments = value.comments;
    this.sanctionService.markSanctionResolve(sanctionMatchRecord).subscribe(response => {
      if (response.flagResult) {
        this.dialogRef.close(sanctionMatchRecord);
      }
      this.callSnackBarService(response);
    }, err => {
      this.callSnackBarService(err);
    });
  }

  callSnackBarService(response: any) {
    this.snackBarService
      .showStatus(response,
        MessageService.SANCTION_RESOLVE_SUCCESS,
        MessageService.SANCTION_RESOLVE_FAILURE);
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/monitoring/actual/sanction/resolvesanction/resolve-sanction.component.ts